import ReactPlayer from 'react-player';
import { FaPlay } from 'react-icons/fa';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

interface LectureVideoPlayerProps {
    isActive: boolean | undefined;
    poster: string | undefined;
    src: string | undefined;
    onEnded?: () => void;
    onFirstPlay?: () => void;
    autoPlay?: boolean;
    posterClassName?: string;
}

export function LectureVideoPlayer({
    isActive,
    poster,
    src,
    onEnded,
    onFirstPlay,
    autoPlay,
    posterClassName,
}: LectureVideoPlayerProps) {
    const [playing, setPlaying] = useState(false);

    const onEndedExtended = () => {
        setPlaying(false);
        if (onEnded) onEnded();
    };

    const onPlayExtended = () => {
        if (!playing && onFirstPlay) onFirstPlay();

        setPlaying(true);
    };

    useEffect(() => {
        setPlaying(autoPlay ?? false);
    }, [isActive, autoPlay]);

    // workaround for react-player v3.4 since it does not support controlsList, disablePictureInPicture and onContextMenu
    useEffect(() => {
        if (playing) {
            const videoElement = document.querySelector('video')!;
            videoElement.setAttribute('controlsList', 'nodownload noplaybackrate');
            videoElement.setAttribute('disablePictureInPicture', 'true');
            videoElement.setAttribute('onContextMenu', 'return false;');
        }
    }, [playing]);

    return (
        <div className="flex-1 overflow-hidden">
            {isActive ? (
                <div className="relative mt-4 aspect-video w-full overflow-hidden rounded-xl bg-cloud-100">
                    <ReactPlayer
                        src={src}
                        playing={playing}
                        light={poster}
                        playIcon={
                            <button
                                className="relative z-10 flex h-16 w-16 items-center justify-center rounded-full bg-product-500 transition-colors hover:bg-product-600"
                                aria-label="Play video"
                            >
                                <FaPlay className="ml-1 text-white" size={20} />
                            </button>
                        }
                        autoPlay={autoPlay || playing}
                        controls={true}
                        controlsList="nodownload"
                        config={{
                            html: {
                              attributes: {
                                controlsList: 'nodownload',
                                onContextMenu: (e: any) => e.preventDefault()
                              }
                            }
                          }}
                        disablePictureInPicture
                        width="100%"
                        height="100%"
                        onEnded={onEndedExtended}
                        onPlay={onPlayExtended}
                        onClickPreview={onPlayExtended}
                    />
                </div>
            ) : (
                <img
                    width={1920}
                    height={1080}
                    src={poster}
                    alt=""
                    className={clsx(
                        'aspect-video w-full rounded-xl bg-cloud-100',
                        posterClassName || 'mb-8 mt-4'
                    )}
                />
            )}
        </div>
    );
}
